import { Icon, IconName } from '@billy/design-system'

import { InputSize } from '../Form/Input'
import * as Styled from './styles'

type IconProps = {
  mode: 'default' | 'lookup'
  isListOpen?: boolean
  onClick?: () => void
  inputSize?: InputSize
}

export const SelectIcon = ({ mode, isListOpen, inputSize, onClick }: IconProps) => {
  const chevronIcon: IconName = isListOpen ? 'chevronUp' : 'chevronDown'

  return (
    <Styled.SelectIconWrapper inputSize={inputSize} onClick={onClick}>
      <Icon icon={mode === 'lookup' ? 'search' : chevronIcon} />
    </Styled.SelectIconWrapper>
  )
}
